var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('h1',{attrs:{"word-wrap":""}},[_vm._v("Herzlich Willkommen - Im Moment befindet sich meine Webseite noch im Aufbau")])])}
var staticRenderFns = []

export { render, staticRenderFns }